import { Injectable } from "@angular/core";
import { FinancialPaths } from "@gipi-paths/financial.paths";
import { ArrayUtil, GIPIAbstractCrudService, GIPIBaseService, GIPIUuid, ObjectUtil, UUIDUtil } from "@gipisistemas/ng-core";
import { Observable } from "rxjs";
import { catchError, map, takeUntil } from "rxjs/operators";
import { FinancialCreditClient } from "../models/credit-client.model";
import { FinancialCreditClientCancelDTO } from "../models/dto/cancel-credit-client.dto";
import { FinancialCreditClientFilterDTO } from "../models/dto/credit-client-filter.dto";
import { FinancialCreditClientDTO } from "../models/dto/credit-client.dto";
import { FinancialDetailCreditClientDTO } from "../models/dto/detail-credit-client.dto";

@Injectable({ providedIn: 'root' })
export class FinancialCreditClientService extends GIPIAbstractCrudService<FinancialCreditClient, FinancialCreditClientFilterDTO> {

    constructor(protected baseService: GIPIBaseService,) {
        super(FinancialPaths.creditClient, 'v1', baseService);
    }

    balance(clientId: GIPIUuid, version?: string): Observable<number> {
        if (!UUIDUtil.isValid(clientId)) {
            throw new Error('O cliente informado não é válido');
        }
        return this.baseService.httpClient.get(this.url(`balance/${clientId}`, version), this.options()).pipe(
            map(this.handleMapper),
            takeUntil(this.handleDestroy),
            catchError(this.handleError)
        );
    }

    cancelCredit(creditClientCancel: FinancialCreditClientCancelDTO, version?: string): Observable<FinancialCreditClient> {
        if (ObjectUtil.isNull(creditClientCancel)) {
            throw new Error('O crédito informado não é válido');
        }
        return this.baseService.httpClient.post(this.url(`cancel-credit`, version), creditClientCancel, this.options()).pipe(
            map(this.handleMapper),
            takeUntil(this.handleDestroy),
            catchError(this.handleError),
        );
    }

    detailClientCredit(creditClientId: GIPIUuid, version?: string): Observable<FinancialDetailCreditClientDTO[]> {
        if (!UUIDUtil.isValid(creditClientId)) {
            throw new Error('O crédito informado não é válido');
        }
        return this.baseService.httpClient.get(this.url(`detail-client-credit/${creditClientId}`, version), this.options()).pipe(
            map(this.handleMapper),
            takeUntil(this.handleDestroy),
            catchError(this.handleError)
        );
    }

    generateCredit(creditClientList: FinancialCreditClientDTO[], version?: string): Observable<FinancialCreditClient[]> {
        if (ArrayUtil.isEmpty(creditClientList)) {
            throw new Error('O crédito informado não é válido');
        }
        return this.baseService.httpClient.post(this.url(`generate-credit`, version), creditClientList, this.options()).pipe(
            map(this.handleMapper),
            takeUntil(this.handleDestroy),
            catchError(this.handleError)
        );
    }

}
